import userService from "../../services/user.service";
import { ActionTypes } from "../Constants/ActionTypes";

export const setSelectedSeason = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_SEASON,
    payload: payload,
  });
};

export const setSelectedEvent = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_EVENT,
    payload: payload,
  });
};

export const setVideoList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_VIDEO_LIST,
    payload: payload,
  });
};

export const deleteVideoFromPastSeason = (dispatch, payload) => {
  userService
    .deleteEditedVideos(payload.eventMediaId)
    .then((res) => {
      dispatch({
        type: ActionTypes.DELETE_VIDEO_FROM_PAST_SEASON,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.DELETE_OR_RENAME_VIDEO,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.UPDATE_NUMBER_OF_VIDEOS_IN_WEEKLIST,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Video Deleted Successfully",
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.DELETE_OR_RENAME_VIDEO,
        payload: err,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const setOffSeasonEvent = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_OFFSEASON_EVENT,
    payload: payload,
  });
};
